<template>
  <div id="app" class="downloads" data-page="downloads">
    <div class="downloads-wrap">
      <div class="downloads-title"></div>
      <div class="downloads-ntitle">
        请确认<span
          class="downloads-ntitle__focus downloads-ntitle__target"
          data-target="standard"
          @click="goStatement"
          >知识产权声明</span
        >后再行使用下载专区内的档案。
      </div>
      <div class="downloads-box-wrap">
        <div class="downloads-box downloads-logo">
          <div class="downloads-box-inner">
            <div class="downloads-box__title">LOGO</div>
            <ul class="downloads-box__list">
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="downloads-box downloads-images">
          <div class="downloads-box-inner">
            <div class="downloads-box__title">图片／背景</div>
            <ul class="downloads-box__list">
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="downloads-box downloads-music">
          <div class="downloads-box-inner">
            <div class="downloads-box__title">音乐</div>
            <ul class="downloads-box__list">
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="downloads-box downloads-bn">
          <div class="downloads-box-inner">
            <div class="downloads-box__title">壁纸</div>
            <ul class="downloads-box__list">
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
              <li class="downloads-box__li">
                <div class="downloads-box__img downloads-box__img--skt"></div>
                <div class="downloads-box__detail">
                  <div
                    class="
                      downloads-box__detail-title
                      downloads-box__detail-title--skt
                    "
                  >
                    <span></span>
                  </div>
                  <div class="downloads-box__info">
                    <div
                      class="
                        downloads-box__info-type downloads-box__info-type--skt
                      "
                    ></div>
                  </div>
                  <a
                    href="javascript:;"
                    class="downloads-box__btn downloads-box__btn--skt"
                  ></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="downloads-notice-box-wrap">
        <div class="downloads-notice-box" data-target="standard">
          <div class="downloads-notice__title">
            《世界弹射物语》知识产权声明
          </div>
          <div class="downloads-notice__inner" id="downloads_live_rules">
            <!-- 「弹射世界」支持您的游戏乐趣、以及与家人和朋友间共享游戏体验。因此，游戏橘子数位科技股份有限公司（以下称本公司）针对您在本规范的范围内分享、发布「弹射世界」的游戏直播或体验影片，本公司不会行使著作权。
            <br />
            1.
            您得将本公司营运之「弹射世界」中的游戏画面发布到影片、图片共享网站、进行游戏实况直播。但除了以下指定的系统外，您仅限使用于非商业用途。以下指定系统将不定时更新。
            <br />
            ○可使用的系统一览
            <br />
            YouTube：YouTube合作伙伴计画
            <br />
            Twitter：Amplify发布者增效项目
            <br />
            Facebook：Facebook游戏实况主、Facebook游戏影片创作者升级计画
            <br />
            niconico动画・niconico实况：创作者奖励计画、niconico频道
            <br />
            Twich：Twitch实况盟友方案、Twitch合作伙伴方案
            <br />
            TwitCasting：TwitCast・营利的动画收益（β）、item收益
            <br />
            Mirrativ：赠礼
            <br />
            OPENREC.tv：OPENREC creators program
            <br />
            2.
            除了2分30秒以下的短片，您发布的影片、图片、转载其他人有关「弹射世界」的文章或插图中皆需要有额外的发想、创意或设计，例如时事和评论。
            <br />
            3.
            若您分享的影片、图片或素材涉及第三人的智慧财产权则不适用本规范内容，您应自行取得第三人之授权，否则应自负一切法律责任。
            <br />
            4.
            您以「弹射世界」之影片或图片，进行二次创作时，应遵守中华民国之法令规范。
            <br />
            5. 若您有下列情事，或有发生下列情事之虞，本公司保留一切法律追诉权。
            <br />
            ●违反本规范的内容。
            <br />
            ●发布之内容易使他人误以为系由本公司或官方人员发布。
            <br />
            ●发布之内容违反事实；或内容让他人误以为您系接受本公司或本公司相关人员赞助、合作等。
            <br />
            ●发布违反中华民国法令、涉及色情、暴力、违反公序良俗或其他本公司判断不适当之内容（支持、鼓励或助长前述事项亦包含在本条范围内）。
            <br />
            ●违反本公司或「弹射世界」官方规范的内容（支持、鼓励或助长前述事项亦包含在本条范围内）。
            <br />
            ●侵害本公司智慧财产权或其他权利。
            <br />
            ●以不正当手段侵入、取得、变造、窜改程式或档案（支持、鼓励或助长前述事项亦包含在本条范围内）。
            <br />
            ●以异常或不当获得之游戏帐号进行游戏、使用外挂程式或其他不当游戏手法（包括但不限于利用BUG等）。
            <br />
            ●损害本公司或是「弹射世界」之观感、评价的内容。
            <br />
            6.
            本公司不会回覆与本规范相关的客服问题。另外，与影片、图片的使用承诺相关的客服问题也不会回覆。请见谅。
            <br />
            7.
            本公司有权随时变更、更新本规范内容，内容一经公布立即生效并视为已取得您的同意。请您于发布影片或图片等素材前先确认本规范最新之内容，并应定期检视是否有更新。
            <br />
            8.
            您进行游戏直播、分享时应对您的行为自行负责，若您因此第三人之间产生任何纷争、对他人产生损害或有违法使用的情况，您应自行解决，本公司概不负责。若因此造成本公司遭到第三人提起申诉、诉讼等一切纠纷时，您应负责解决，并对本公司因此所受之损害负担赔偿责任（包括但不限于诉讼费、律师费、名誉损失）。
            <br />
            9.
            「弹射世界」的智慧财产权皆属于本公司所有，并未因本规范而将著作权让与或转授权给您。
            <br />
            10.
            本规范未尽事宜概以中华民国法律为准据法，若本公司与您之间因为本著作内容产生纷争，双方合意以台湾台北地方法院为第一审管辖法院。 -->
          </div>
        </div>
      </div>
      <div class="downloads-mb-wrap">
        <div class="downloads-mb-box">
          <div class="downloads-mb__text">
            <p>此页面内容仅供PC使用。</p>
            <p>请使用PC浏览。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articlenNews } from "@api/index";
import { VUE_APP_API_URL } from "@utils/index";
import { mapGetters } from "vuex";

export default {
  name: "Downloads",
  components: {},
  data() {
    return {
      downloadList: [],
      baseUrl: VUE_APP_API_URL
    };
  },
  computed: mapGetters(["initData"]),
  watch: {
    initData(e) {
      if (!e.frament.length) return;
      let that = this;
      e.frament.map(e => {
        const __content = that
          .$("<div>")
          .html(e.content)
          .text();
        if (e.position === "live_rule") {
          that.$("#downloads_live_rules").html(__content);
        }
      });
    }
  },
  mounted: function() {
    window.$("#LT_age").remove();
    let that = this;
    that.initPage();
    that.initData2(that.initData);
  },
  methods: {
    goStatement() {
      let timer = setInterval(() => {
        window.scrollTo(0, 3730);
        let wTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (wTop === 3730) {
          clearInterval(timer);
        }
      }, 20);
    },
    downloadHTMLRender(data, type) {
      let that = this;
      var imgHTML = "";
      var fileType = "";
      var memo = "";
      var fileSize = "";
      if (type !== 3) {
        imgHTML = '<img src="' + that.baseUrl + data.fileUrl + '" alt="">';
      }
      if (data.memo !== null) {
        memo = "<span>" + data.memo + "</span>";
      }
      if (data.fileSize !== null) {
        fileSize = "<span>" + data.fileSize + "</span>";
      }
      fileType = data.fileUrl.substr(data.fileUrl.lastIndexOf(".") + 1);
      var downloadHTML =
        '<li class="downloads-box__li">\
            <div class="downloads-box__img" >' +
        imgHTML +
        '</div>\
            <div class="downloads-box__detail">\
                <div class="downloads-box__detail-title">\
                    <span>' +
        data.title +
        "</span>\
                    " +
        memo +
        '\
                </div>\
                <div class="downloads-box__info">\
                    <div class="downloads-box__info-type">\
                        <span>格式：' +
        fileType +
        "</span>\
                        " +
        fileSize +
        '\
                    </div>\
                </div>\
                <a href="' +
        that.baseUrl +
        data.fileUrl +
        '" class="downloads-box__btn" target="_blank">\
                    <span>下載</span>\
                    <img src="@assets/images/downloads/download-icon.png" alt="">\
                </a>\
            </div>\
        </li>';
      return downloadHTML;
    },

    initPage() {
      let that = this;
      articlenNews({
        class_id: 7,
        page: 0
      }).then(res => {
        const _new_list = res.new_list;
        _new_list.map(e => {
          let type = 1;
          switch (e.class_id) {
            case 8:
              type = 1;
              break;
            case 9:
              type = 2;

              break;
            case 10:
              type = 3;

              break;
            case 11:
              type = 4;

              break;
            default:
              break;
          }
          that.downloadList.push({
            fileSize: `大小：${e.capacity} KB`,
            fileUrl: e.image,
            memo: e.detail || e.description,
            seq: e.content_id,
            title: e.title,
            type
          });
        });
        var logoArr = [];
        var imageArr = [];
        var musicArr = [];
        var bannerArr = [];
        var logoHTML = "";
        var imageHTML = "";
        var musicHTML = "";
        var bannerHTML = "";
        that.downloadList.forEach(function(v) {
          if (v.type == 1) {
            logoArr.push(v);
          }
          if (v.type == 2) {
            imageArr.push(v);
          }
          if (v.type == 3) {
            musicArr.push(v);
          }
          if (v.type == 4) {
            bannerArr.push(v);
          }
        });

        if (logoArr.length) {
          logoArr.forEach(function(v) {
            logoHTML += that.downloadHTMLRender(v, 1);
          });
          that.$(".downloads-logo .downloads-box__list").html(logoHTML);
        }

        if (imageArr.length) {
          imageArr.forEach(function(v) {
            imageHTML += that.downloadHTMLRender(v, 2);
          });
          that.$(".downloads-images .downloads-box__list").html(imageHTML);
        }

        if (musicArr.length) {
          musicArr.forEach(function(v) {
            musicHTML += that.downloadHTMLRender(v, 3);
          });
          that.$(".downloads-music .downloads-box__list").html(musicHTML);
        }

        if (bannerArr.length) {
          bannerArr.forEach(function(v) {
            bannerHTML += that.downloadHTMLRender(v, 4);
          });
          that.$(".downloads-bn .downloads-box__list").html(bannerHTML);
        }
      });
    },
    initData2(e) {
      if (!e.frament.length) return;
      let that = this;
      e.frament.map(e => {
        const __content = that
          .$("<div>")
          .html(e.content)
          .text();
        if (e.position === "live_rule") {
          that.$("#downloads_live_rules").html(__content);
        }
      });
    }
  }
};
</script>
<style scoped></style>
